
import {defineComponent, PropType} from "vue";

export default defineComponent({
  name: 'ShowEye',
  props: {
    fillColor: {
      type: String,
      default: '#0550D1',
    }
  }
})
